import { HcLovedOne } from "./hc-loved-one.model";
import { HcNotificationSetup } from "./hc-notification-setup.model";
import { HcPhoneSetup } from "./hc-phone-setup.model";
import { HcSchedule } from "./hc-schedule.model";
import { HcSmsSetup } from "./hc-sms-setup.model";

export interface HcFlow {
  _id: string;
  csId: string;
  name: string;
  description: string;
  status: HcFlowStatus;
  createdAt: Date;
  updatedAt: Date;
  lovedOneId: string;
  lovedOne?: HcLovedOne;
  schedule: HcSchedule;
  callType: HcCallType;
  setup: HcPhoneSetup | HcSmsSetup;
  notificationSetup?: HcNotificationSetup;
}

export enum HcFlowStatus {
  ACTIVE = 'HcFlowStatus.active',
  INACTIVE = 'HcFlowStatus.inactive',
}

export enum HcCallType {
  VOICE = 'HcCallType.voice',
  TEXT = 'HcCallType.text',
  // APP = 'HcCallType.application', // Future use
}

export interface HcFlowTemplate {
  _id: string;
  name: string;
  description: string;
  status: HcFlowStatus;
  createdAt: Date;
  updatedAt: Date;
  schedule: HcSchedule;
  callType: HcCallType;
  setup: HcPhoneSetup | HcSmsSetup;
  notificationSetup?: HcNotificationSetup;
}
